function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useEffect, useState } from 'react';
import { filterSupportedEventListenerOptions } from '../../utils';
import useDesignTokens from '../useDesignTokens';
/**
 * A hook to get the current breakpoint.
 *
 * Generally, we will want to do as much of our styling as possible with CSS.
 * But, there are a small number of cases where we want to swap a property
 * or entire component based on the current breakpoint.
 *
 * The hook uses `window.matchMedia` with listeners to check when the breakpoint
 * has changed (supported by IE >= 10, see https://caniuse.com/matchmedia). This
 * is significantly less expensive than binding a resize event listener.
 */

var useBreakpoints = function useBreakpoints() {
  var breakpoints = ['xs', 'sm', 'md', 'lg'];

  var _useDesignTokens = useDesignTokens(),
      grid = _useDesignTokens.grid;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentBreakpoint = _useState2[0],
      setCurrentBreakpoint = _useState2[1];

  useEffect(function () {
    var mediaQueries = breakpoints.slice(1).map(function (bp) {
      return {
        bp: bp,
        query: window.matchMedia("(min-width: ".concat(grid[bp], "px)"))
      };
    });
    var evtListenerOpts = filterSupportedEventListenerOptions({
      passive: true
    });
    /**
     * Check all media queries and set the breakpoint to the highest that matches.
     */

    var setHighestBreakpoint = function setHighestBreakpoint() {
      var highestBreakpoint = mediaQueries.reduce(function (currentBp, _ref) {
        var query = _ref.query,
            nextBp = _ref.bp;
        return query.matches ? nextBp : currentBp;
      }, breakpoints[0]);
      setCurrentBreakpoint(highestBreakpoint);
    };

    mediaQueries.forEach(function (_ref2) {
      var query = _ref2.query;

      // Use `addListener` as a fallback for older browsers
      if (!query.addEventListener && query.addListener) {
        query.addListener(setHighestBreakpoint);
        return;
      } // If running IE 9, no media queries for you


      if (!query.addEventListener) {
        return;
      }

      query.addEventListener('change', setHighestBreakpoint, evtListenerOpts);
    });
    setHighestBreakpoint();
    return function () {
      mediaQueries.forEach(function (_ref3) {
        var query = _ref3.query;
        query.removeEventListener('change', setHighestBreakpoint);
      });
    };
  }, []);
  /**
   * Check if the screen is greater than or equal to the given breakpoint.
   */

  var isAboveBreakpoint = function isAboveBreakpoint(bp) {
    var fallbackState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!currentBreakpoint) {
      return fallbackState; // for when the useEffect hasn't fired yet
    }

    return breakpoints.indexOf(bp) <= breakpoints.indexOf(currentBreakpoint);
  };
  /**
   * Check if the screen is less than or equal to the given breakpoint.
   */


  var isBelowBreakpoint = function isBelowBreakpoint(bp) {
    var fallbackState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!currentBreakpoint) {
      return fallbackState; // for when the useEffect hasn't fired yet
    }

    return breakpoints.indexOf(bp) >= breakpoints.indexOf(currentBreakpoint);
  };

  return {
    currentBreakpoint: currentBreakpoint,
    isAboveBreakpoint: isAboveBreakpoint,
    isBelowBreakpoint: isBelowBreakpoint
  };
};

export default useBreakpoints;